const BadgeService = function BadgeService() {
};

BadgeService.prototype.showSuperSaversBadge = function (product) {
    const shelfTalkerType = product.ShelfTalkerType || '';
    return shelfTalkerType.toLowerCase() === 'sa';
};

BadgeService.prototype.isShelfTalkerTypeGreatValue = function (product) {
    const shelfTalkerType = product.ShelfTalkerType || '';
    return shelfTalkerType.toLowerCase() === 'gv';
};

BadgeService.prototype.showPercentageOffBadge = function(product) {
    return (product.PercentageOffTag.TagType !== 'None' && product.Price && !product.ProductData.hideprice)
        || (product.FixedPricePromoTag.TagType !== 'None' && product.Price && !product.ProductData.hideprice);
};

module.exports = BadgeService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/badges/badge-service.js
 **/